interface WishlistDigest {
  id: string
  name: string
}

export interface WishlistItem {
  code: string
}
export interface WishlistEvent extends WishlistItem {
  editMode?: boolean
}

export function useWishlist() {
  const lastUsedWishlist = useSessionStorage('lastUsedWishlist', {
    name: '',
    id: '',
  } as WishlistDigest)
  const addToWishlistEvt = useEventBus<WishlistEvent>('addToWishlist')
  const deleteFromWishlistEvt = useEventBus<WishlistEvent>('deleteFromWishlist')

  function add({ code }: WishlistItem) {
    addToWishlistEvt.emit({ code })
  }

  function edit({ code }: WishlistItem) {
    addToWishlistEvt.emit({ code, editMode: true })
  }

  function remove(item: WishlistItem) {
    deleteFromWishlistEvt.emit(item)
  }

  function toggle(item: WishlistItem, currentStatus: boolean) {
    if (currentStatus) {
      remove(item)
    } else {
      add(item)
    }
  }

  return {
    lastUsedWishlist,
    addToWishlistEvt,
    deleteFromWishlistEvt,
    add,
    edit,
    remove,
    toggle,
  }
}
